import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeFlagsConversationsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeFlagsConversationsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeFlagsConversationsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeFlagsConversationsResponseDataSchema>
>

export const getBackofficeFlagsConversationsQuery = ({
  query,
  onSuccess,
}: {
  query: Query
  onSuccess?: (data: Response) => void
}) =>
  queryOptions({
    queryKey: ["backofficeFlagsConversations", query],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/flags/conversations", {
        params: query,
      })
      onSuccess?.(data)
      return data
    },
  })
